import React from "react";
import RussianMap from "../../../maps/RussianMap";
import PropTypes from "prop-types";
import styles from "./MainMap.module.styl";

export default function MainMap({ onMapRegionClick, highlightedRegions, withoutHighlightRegions }) {
    return (
        <div className={styles.container} data-test-name="card_rus">
            <RussianMap
                withoutHighlightRegions={withoutHighlightRegions}
                highlightedRegions={highlightedRegions}
                onMapRegionClick={onMapRegionClick}
            />
        </div>
    );
}

MainMap.propTypes = {
    onMapRegionClick: PropTypes.func.isRequired,
    highlightedRegions: PropTypes.array.isRequired,
    withoutHighlightRegions: PropTypes.array.isRequired,
};
